export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const DD_MM_YYYY = 'DD.MM.YYYY';
export const D_M_YY = 'D.M.YY';
export const MOMENT_LL = 'LL';
export const DATEPICKER_FORMAT = 'dd.MM.yyyy';
